import { ArrayMinSize, IsArray, IsIn, IsNotEmpty, Length } from 'class-validator';
import { CaseLineDto } from './case-line.dto';
import { CaseType } from './case-type.enum';

/**
 * DTO to create a new case. Other Case details are enriched through the update/patch API
 */
export class CaseCreateDto {
  /**
   * Account against wich the case should be created
   */
  @IsNotEmpty()
  @Length(18, 24)
  public accountId: string;

  /**
   * Type of the case
   */
  @IsIn([CaseType.Return, CaseType.Warranty])
  public type: CaseType;

  /**
   * Selected products/lines for the Case
   */
  @IsArray()
  @ArrayMinSize(1)
  public lines: CaseLineDto[];
}
